import React, { useState } from "react";
import * as XLSX from "xlsx";
import { useKomisiBooking } from "contexts/KomisiBookingContext";
import Swal from "sweetalert2";

const ExportExcelSusuk = ({ startDate, endDate }) => {
  const { bookings } = useKomisiBooking();
  const [isLoading, setIsLoading] = useState(false); // 🔹 State untuk loading

  const handleExport = () => {
    if (!bookings || !bookings.data || bookings.data.length === 0) {
      Swal.fire("Gagal!", "Tidak ada data untuk diekspor!", "error");
      return;
    }

    // 🔹 Tampilkan loading di Swal
    Swal.fire({
      title: "Exporting...",
      text: "Harap tunggu, sedang memproses file...",
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    setIsLoading(true);

    setTimeout(() => {
      try {
        // 🔹 Filter data sesuai tanggal yang dipilih
        const filteredData = bookings.data.filter((booking) => {
          return booking.reservation_date >= startDate && booking.reservation_date <= endDate;
        });

        if (filteredData.length === 0) {
          Swal.fire("Gagal!", `Tidak ada data untuk tanggal ${startDate} - ${endDate}`, "warning");
          setIsLoading(false);
          return;
        }

        // 🔹 Tambahkan judul laporan di baris pertama
        const title = [`Susuk Agent Report: ${startDate} - ${endDate}`];

        // 🔹 Konversi data ke format Excel
        const dataToExport = filteredData.map((booking) => ({
          "Kode Booking": booking.code,
          "Tanggal Reservasi": booking.reservation_date,
          "Nama Tamu": booking.guest_name,
          "Agent": booking.agent?.name || "N/A",
          "Jumlah Pax": booking.guest_pax,
          "Total Harga": `Rp. ${parseInt(booking.total_price).toLocaleString("id-ID")}`,
          "Susuk Agent": `Rp. ${parseInt(booking.susuk_agent || 0).toLocaleString("id-ID")}`,
          "Catatan Pembayaran": booking.payment_note || "-",
          "Aktivitas": booking.activities.map((a) => `${a.activity} (${a.qty})`).join(", "),
        }));

        // 🔹 Buat file Excel
        const worksheet = XLSX.utils.json_to_sheet(dataToExport, { origin: "A2" });
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, `Report_${startDate}_${endDate}`);

        // 🔹 Tambahkan judul di baris pertama
        XLSX.utils.sheet_add_aoa(worksheet, [title], { origin: "A1" });

        // 🔹 Save file using Blob and anchor with download attribute for better Android compatibility
        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = window.URL.createObjectURL(data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Susuk_Report_${startDate}_${endDate}.xlsx`);
        document.body.appendChild(link);
        link.click();

        // 🔹 Cleanup
        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }, 100);

        // 🔹 Tampilkan notifikasi sukses
        Swal.fire("Sukses!", `File berhasil diekspor!`, "success");
      } catch (error) {
        console.error("Export Excel Error:", error);
        Swal.fire("Gagal!", "Terjadi kesalahan saat mengekspor data.", "error");
      } finally {
        setIsLoading(false);
      }
    }, 1000); // Simulasi delay agar loading terlihat
  };

  return (
    <button
      className="btn btn-outline-primary"
      onClick={handleExport}
      disabled={isLoading} // 🔹 Disable tombol saat loading
    >
      {isLoading ? (
        <>
          <span className="spinner-border spinner-border-sm me-2" role="status"></span>
          Exporting...
        </>
      ) : (
        <>📥 Export Excel ({startDate} - {endDate})</>
      )}
    </button>
  );
};

export default ExportExcelSusuk;
